import React, {useEffect, useState} from 'react'
import {BasicLayout} from '../../modules/Layouts/basicLayout'
import DarkInvoce from '../../media/felsv/dark_invoice_icon.svg'
import WhiteInvoce from '../../media/felsv/white_invoice_icon.svg'
import DarkBill from '../../media/felsv/dark_bill_icon.svg'
import WhiteBill from '../../media/felsv/white_bill_icon.svg'
import DarkPuzzle from '../../media/felsv/DarkOtrosDocuments.svg'
import WhitePuzzle from '../../media/felsv/WhiteOtrosDocuments.svg'
import DarkUsuarios from '../../media/felsv/dark_users_icon.svg'
import WhiteUsuario from '../../media/felsv/white_users_icon.svg'
import WhiteSuscripcion from '../../media/felsv/WhiteSuscripcion.svg'
import DarkSuscripcion from '../../media/felsv/DarkSuscripcion.svg'
import './home.css'
import CardMenu from '../../components/CardMenu/CardMenu'
import {KEYS} from '../../constants/keysStorage'
import FacturadorLogo from '../../media/logos/PNG/ISO_FELES_Facturador.png'
import SupervisorLogo from '../../media/logos/PNG/ISO_FELES_Supervisor.png'
import {useDispatch} from 'react-redux'
import {setActiveModuleDoc} from '../../actions/documentos/documentos.actions'
import useCreditoFiscal from '../../actions/credito-fiscal.actions'
import { BannerElegirSucursal } from '../../components/Banner/BannerElegirSucursal'

const Home = () => {
  const [activo, setActivo] = useState(0)
  const [supervisor, setSupervisor] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    let rol = localStorage.getItem(KEYS.ROL)?.toString() || '0'
    setSupervisor(rol === '2')
  }, [])

  useEffect(() => {
    // Cambiar el ícono del navegador
    const link = document.querySelector('#icon-logo') as HTMLLinkElement

    if (link) {
      if (supervisor) {
        link.href = SupervisorLogo
      } else {
        link.href = FacturadorLogo
      }
    }
  }, [supervisor])

  const navegarCreditoFiscal = () => {
    dispatch(setActiveModuleDoc({title: 'Comprobante crédito fiscal', idDoc: '03'}))
  }

  return (
    <BasicLayout>
      <div className='header-title'>
        <h2 className='xl home-h2-titles'>
          Bienvenido al Sistema de <span className='color-secondary'>Facturación Electrónica</span>
        </h2>
      </div>
      <div className='separador'></div>
      <BannerElegirSucursal />
      <div id='w-node-_902d12c4-9c9b-5148-7bf8-9dd46eb7026e-04e476cd' className='w-layout-layout home-dashboard wf-layout-layout mt-16'>
        <CardMenu
          to='/emitir-factura/formulario'
          activar={() => setActivo(1)}
          desactivar={() => setActivo(0)}
          activo={activo === 1}
          WhiteIcon={WhiteInvoce}
          DarkIcon={DarkInvoce}
          title='Emitir factura'
          description='Genera facturas de manera rápida y sencilla. Agiliza y simplifica tu proceso de facturación, ayudándote a mantener un control preciso y eficiente de tus transacciones comerciales. Una vez emitida, la factura se generará en formato digital y se enviará al cliente designado. Además, se almacenará una copia para futuras consultas y registros.'
          autoFocus={true}
          disabled={localStorage.getItem(KEYS.LIMITAR_USO_FELES) === 'true'}
        />
        <CardMenu
          to='/otros-documentos/credito-fiscal'
          activar={() => setActivo(2)}
          desactivar={() => setActivo(0)}
          activo={activo === 2}
          WhiteIcon={WhiteInvoce}
          DarkIcon={DarkInvoce}
          title='Emitir crédito fiscal'
          description='Es un documento que muestra cuántos impuestos indirectos, como el IVA, ha pagado una empresa o persona en sus compras. Se utiliza para reclamar un crédito fiscal y reducir la carga impositiva total. Es esencial para el cumplimiento fiscal y la gestión financiera adecuada.'
          onClick={navegarCreditoFiscal}
          disabled={localStorage.getItem(KEYS.LIMITAR_USO_FELES) === 'true'}
        />
        <CardMenu
          to='/history-invoice'
          activar={() => setActivo(3)}
          desactivar={() => setActivo(0)}
          activo={activo === 3}
          WhiteIcon={WhiteBill}
          DarkIcon={DarkBill}
          title='Historial de documentos'
          description='Mantén un control efectivo de tus operaciones comerciales. Accede al registro completo de todos tus documentos emitidos y realiza un seguimiento detallado de tus registros financieros. Esta función te brinda una visión general de tus transacciones realizadas y te permite consultar, imprimir, enviar y descargar todos tus documentos emitidos.'
          disabled={localStorage.getItem(KEYS.LIMITAR_USO_FELES) === 'true'}
        />
        <CardMenu
          to='/otros-documentos'
          activar={() => setActivo(4)}
          desactivar={() => setActivo(0)}
          activo={activo === 4}
          WhiteIcon={WhitePuzzle}
          DarkIcon={DarkPuzzle}
          title='Otros documentos'
          description='Accede a una variedad de funciones adicionales para tu sistema de facturación. Otros documentos te brinda un listado de funciones adicionales tales como: consultar comprobantes de créditos fiscales, retenciones, liquidaciones, realizar notas de crédito y débito y más. Explora las opciones disponibles y personaliza tu experiencia en el sistema de facturación.'
          disabled={localStorage.getItem(KEYS.LIMITAR_USO_FELES) === 'true'}
        />
        {supervisor && (
          <>
            <CardMenu
              to='/gestion-usuarios'
              activar={() => setActivo(5)}
              desactivar={() => setActivo(0)}
              activo={activo === 5}
              WhiteIcon={WhiteUsuario}
              DarkIcon={DarkUsuarios}
              title='Gestión de usuarios'
              description='Optimiza la gestión de tus usuarios y sucursales con un acceso integral al mantenimiento de toda tu infraestructura empresarial. Esta funcionalidad te ofrece una panorámica detallada de tus usuarios y te habilita para administrar, editar y consultar de manera eficiente todos tus registros, sucursales y documentos.'
              disabled={localStorage.getItem(KEYS.LIMITAR_USO_FELES) === 'true'}
            />
            <CardMenu
              to='/suscripcion/info'
              activar={() => setActivo(6)}
              desactivar={() => setActivo(0)}
              activo={activo === 6}
              WhiteIcon={WhiteSuscripcion}
              DarkIcon={DarkSuscripcion}
              title='Suscripción'
              description='Verifica tu suscripción, esta función te detalla el plan suscrito, fecha de pago, cantidad de facturas emitidas y el historial de pagos realizados.'
              // disabled={localStorage.getItem(KEYS.LIMITAR_USO_FELES) === 'true'}
            />
          </>
        )}
      </div>
    </BasicLayout>
  )
}

export default Home
